{
	"language": {
		"aria": "Cambiar idioma"
	},
	"placeholder": {
		"title": "Tu centro del candidato está en camino",
		"body": "Aquí todavía no hay nada. Te enviaremos un enlace por correo electrónico cuando esté listo."
	},
	"not_found": {
		"title": "Página no encontrada",
		"body": "Comprueba el enlace que has seguido o utiliza el enlace de tu correo electrónico."
	},
	"error_boundary": {
		"reload": "Recargar la página"
	},
	"login": {
		"loading": "Cargando…",
		"title": "Inicia sesión en tu centro del candidato",
		"intro": "Introduce tu dirección de correo electrónico para ver tus candidaturas.",
		"email_label": "Dirección de correo electrónico",
		"email_placeholder": "tucorreo@ejemplo.com",
		"submit": "Iniciar sesión",
		"sending": "Enviando…",
		"sent": {
			"title": "Revisa tu correo electrónico",
			"body": "Si {{email}} coincide con una candidatura, te enviaremos un enlace de inicio de sesión.",
			"retry": "¿No lo has recibido? Comprueba la dirección e inténtalo de nuevo"
		},
		"resent": {
			"title": "Te hemos enviado un nuevo enlace de inicio de sesión",
			"body": "El enlace que has abierto ha caducado. Si tu correo electrónico coincide con una candidatura, te enviaremos un nuevo enlace de inicio de sesión. Abre la misma página.",
			"request_manually": "¿No lo has recibido? Solicita un nuevo enlace"
		},
		"request_error": {
			"throttled": "Demasiados intentos. Espera un minuto e inténtalo de nuevo.",
			"invalid_email": "Introduce una dirección de correo electrónico válida.",
			"generic": "Se ha producido un error. Inténtalo de nuevo."
		},
		"unknown_organisation": {
			"title": "Página no encontrada",
			"body": "Comprueba el enlace que has seguido o utiliza el enlace de tu correo electrónico."
		},
		"error": {
			"title": "Se ha producido un error",
			"body": "No hemos podido cargar esta página. Inténtalo de nuevo en un momento."
		}
	},
	"organisations": {
		"title": "Tus candidaturas",
		"intro": "Elige una empresa para ver las candidaturas que le has enviado.",
		"count_one": "{{count}} candidatura",
		"count_other": "{{count}} candidaturas",
		"empty": {
			"title": "Todavía no hay candidaturas",
			"body": "Cuando te inscribas en una empresa, aparecerá aquí."
		},
		"error": "No hemos podido cargar tus empresas. Inténtalo de nuevo en un momento.",
		"log_out": "Cerrar sesión",
		"logging_out": "Cerrando sesión…"
	},
	"submissions": {
		"title": "Candidaturas anteriores",
		"back_to_organisations": "Todas las empresas",
		"cv_uploaded": "CV subido",
		"empty": {
			"title": "Todavía no hay candidaturas",
			"body": "Las candidaturas que envíes a {{organisation}} aparecerán aquí."
		},
		"error": "No hemos podido cargar tus candidaturas. Inténtalo de nuevo en un momento.",
		"log_out": "Cerrar sesión",
		"logging_out": "Cerrando sesión…"
	},
	"profile": {
		"link": {
			"title": "Tu perfil",
			"cv_added": "CV añadido",
			"cv_missing": "Aún no hay CV"
		},
		"back": "Volver a la candidatura",
		"context": "{{campaign}} · {{organisation}}",
		"contact_consent": "Aceptas que te contacten sobre este empleo.",
		"cv": {
			"title": "CV",
			"upload": {
				"title": "Sube tu CV",
				"drop_hint": "o arrástralo y suéltalo aquí",
				"constraints": "{{types}}, hasta {{size}} MB",
				"uploading": "Subiendo {{fileName}}…",
				"done": "CV subido",
				"error_type": "Este tipo de archivo no es compatible. Tipos permitidos: {{types}}.",
				"error_size": "Este archivo es demasiado grande. El tamaño máximo es de {{size}} MB."
			},
			"remove": {
				"label": "Eliminar {{fileName}}",
				"question": "¿Eliminar {{fileName}}?",
				"consequence": "La empresa ya no podrá verlo. Esta acción no se puede deshacer.",
				"confirm": "Eliminar CV",
				"cancel": "Cancelar",
				"removing": "Eliminando…",
				"error": "No se ha podido eliminar tu CV. Inténtalo de nuevo."
			}
		},
		"work_history": {
			"title": "Experiencia laboral",
			"description": "Cuéntanos tu experiencia laboral relevante: dónde trabajaste, qué hacías allí y cuánto tiempo trabajaste allí. Puedes añadir más de un trabajo si son relevantes.",
			"placeholder": "Describe un trabajo que hayas tenido",
			"input_label": "Detalles del trabajo",
			"save": "Guardar",
			"saving": "Guardando…",
			"cancel": "Cancelar",
			"edit": "Editar",
			"remove": "Eliminar",
			"add_another": "Añadir otro trabajo",
			"error_empty": "Escribe algo antes de guardar.",
			"error_limit": "Puedes añadir hasta {{max}} trabajos.",
			"unsaved_changes": "Tienes cambios sin guardar en tu experiencia laboral. ¿Quieres salir de todos modos y perderlos?",
			"hints": {
				"label": "Detalles de este trabajo",
				"included": "incluido",
				"missing": "aún no incluido"
			}
		},
		"education": {
			"title": "Formación",
			"description": "Cuéntanos tu formación relevante: qué estudiaste, dónde y cuándo. Cuentan los títulos, centros de estudio, cursos y certificados. Puedes añadir más de una.",
			"placeholder": "Describe un título, centro de estudios o curso",
			"input_label": "Detalles de la formación",
			"save": "Guardar",
			"saving": "Guardando…",
			"cancel": "Cancelar",
			"edit": "Editar",
			"remove": "Eliminar",
			"add_another": "Añadir otra formación",
			"error_empty": "Escribe algo antes de guardar.",
			"error_limit": "Puedes añadir hasta {{max}} formaciones.",
			"unsaved_changes": "Tienes cambios sin guardar en tu formación. ¿Quieres salir de todos modos y perderlos?"
		},
		"licenses": {
			"title": "Permisos y certificaciones",
			"description": "Cuéntanos qué permisos y certificaciones tienes, como el carné de conducir, el carné de carretillero o el carné de manipulador de alimentos. Indica cuándo lo obtuviste y cuándo caduca, si caduca. Puedes añadir más de uno.",
			"placeholder": "Describe un permiso o certificación",
			"input_label": "Detalles del permiso",
			"save": "Guardar",
			"saving": "Guardando…",
			"cancel": "Cancelar",
			"edit": "Editar",
			"remove": "Eliminar",
			"add_another": "Añadir otro permiso",
			"error_empty": "Escribe algo antes de guardar.",
			"error_limit": "Puedes añadir hasta {{max}} permisos.",
			"unsaved_changes": "Tienes cambios sin guardar en tus permisos. ¿Quieres salir de todos modos y perderlos?"
		}
	},
	"submission": {
		"back": "Volver a mis candidaturas",
		"back_short": "Volver",
		"not_found": {
			"title": "Candidatura no encontrada",
			"body": "Esta candidatura no existe o no es una de las tuyas."
		},
		"result": {
			"heading": "La pantalla de confirmación que viste después de inscribirte"
		},
		"summary": {
			"title": "Resumen de tus respuestas",
			"submitted_on": "Enviaste este formulario el",
			"submitted_more_than_once": "Rellenaste este formulario más de una vez. Fusionaremos tu perfil automáticamente; la candidatura que se muestra a continuación es la más reciente."
		}
	}
}
